import { render, staticRenderFns } from "./CreateMisc.vue?vue&type=template&id=c26748a4&lang=pug&"
import script from "./CreateMisc.vue?vue&type=script&lang=ts&"
export * from "./CreateMisc.vue?vue&type=script&lang=ts&"
import style0 from "./CreateMisc.vue?vue&type=style&index=0&id=c26748a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports